export default "<section id=\"subscribe\">\n    <h1>Become a Beatster</h1>\n\n    <button ui-sref=\"join\">Join / Login</button>\n</section>";